import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useParams } from "react-router-dom";
import { Col } from "react-bootstrap";
import ValueChangeCircle from "../../components/charts/my_charts/ValueChangeCircle";
import ValueChangeCircle2 from "../../components/charts/my_charts/ValueChangeCircle2";
import SaudiFacultyPercentageChart from "../../components/charts/my_charts/SaudiFacultyPercentageChart";
import PieUChart from "../../components/charts/my_charts/PieUChart";
import KPIChartsContainer2 from "../../components/charts/my_charts/KPIChartsContainer2";

import ApexLine3 from "../../components/Programs/ApexLine3";
import ApexLine4 from "../../components/Programs/ApexLine4";
import ApexLineMainDomains from "../../components/Programs/ApexLineMainDomains";
import SubjectTablePage from "../../components/Programs/SubjectTablePage";

const ProgramDetails = () => {
  const { id } = useParams();
  const getAcademicYearIdFromQuery = () => {
    const params = new URLSearchParams(window.location.search);
    const year = params.get("year");
    return year ? Number(year) : null;
  };

  const academicYearId = getAcademicYearIdFromQuery();

  const [startedStudents, setStartedStudents] = useState(0);
  const [completionStudentAverage, setCompletionStudentAverage] = useState(0);
  const [completedMin, setCompletedMin] = useState(0);
  const [exitPoints, setExitPoints] = useState(0);
  const [totalFaculty, setTotalFaculty] = useState(0);
  const [facultyRatios, setFacultyRatios] = useState(null);
  const [phdStats, setPhdStats] = useState(null);
  const [ploCodes, setPloCodes] = useState([]);

  const [targetsMap, setTargetsMap] = useState({});
  const [seriesData, setSeriesData] = useState({
    overall_pct: [],
    male_pct: [],
    female_pct: [],
  });
  const [loading, setLoading] = useState(true);
  const [summaryData, setSummaryData] = useState({ categories: [], data: [] });
  const [subDomainChart, setSubDomainChart] = useState({
    series: [],
    categories: [],
  });
  const [mainDomainChart, setMainDomainChart] = useState({
    series: [],
    categories: [],
  });

  const fetchStartedStudents = async () => {
    fetch(
      `https://plo.areez.co/api/program/started_students?academic_year_id=${academicYearId}&program_id=${id}`
    )
      .then((res) => res.json())
      .then((data) => {
        setStartedStudents(data.total_started_students);
      })
      .catch((err) => console.error("فشل تحميل عدد الطلاب:", err));
  };

  const fetchCompletionStudentAverage = async () => {
    fetch(
      `https://plo.areez.co/api/program/completed_students?academic_year_id=${academicYearId}&program_id=${id}`
    )
      .then((res) => res.json())
      .then((data) => {
        setCompletionStudentAverage(data.total_completed_students);
      })
      .catch((err) => console.error("فشل تحميل عدد الطلاب:", err));
  };

  const fetchCompletedMin = async () => {
    fetch(
      `https://plo.areez.co/api/program/completed_min?academic_year_id=${academicYearId}&program_id=${id}`
    )
      .then((res) => res.json())
      .then((data) => {
        setCompletedMin(data.total_completed_min_duration);
      })
      .catch((err) => console.error("فشل تحميل عدد الطلاب:", err));
  };

  const fetchEexitPoints = async () => {
    fetch(
      `https://plo.areez.co/api/program/exit_points?academic_year_id=${academicYearId}&program_id=${id}`
    )
      .then((res) => res.json())
      .then((data) => {
        setExitPoints(data.total_exit_points_completed);
      })
      .catch((err) => console.error("فشل تحميل عدد الطلاب:", err));
  };

  const fetchTotalFaculty = async () => {
    fetch(
      `https://plo.areez.co/api/program/total_faculty?academic_year_id=${academicYearId}&program_id=${id}`
    )
      .then((res) => res.json())
      .then((data) => {
        setTotalFaculty(data.total_faculty);
      })
      .catch((err) => console.error("فشل تحميل عدد الطلاب:", err));
  };

  const fetchFacultyRatios = async () => {
    fetch(
      `https://plo.areez.co/api/faculty/nationality_gender_ratios?program_id=${id}&academic_year_id=${academicYearId}`
    )
      .then((res) => res.json())
      .then((data) => setFacultyRatios(data))
      .catch((err) => console.error("فشل تحميل نسب هيئة التدريس:", err));
  };

  const fetchPhdStats = async () => {
    fetch(
      `https://plo.areez.co/api/faculty/phd_comparison?program_id=${id}&academic_year_id=${academicYearId}`
    )
      .then((res) => res.json())
      .then((data) => setPhdStats(data))
      .catch((err) => console.error("فشل تحميل بيانات الدكتوراه:", err));
  };


  const maleData = facultyRatios
    ? [
        facultyRatios.saudi_male_percentage,
        facultyRatios.non_saudi_male_percentage,
      ]
    : [];

  const femaleData = facultyRatios
    ? [
        facultyRatios.saudi_female_percentage,
        facultyRatios.non_saudi_female_percentage,
      ]
    : [];

  const categories = ["سعوديين", "غير سعوديين"];


 

  const fetchSummaryData = async () => {
    try {
      const res = await fetch(
        `https://plo.areez.co/api/plo/batches/summary?program_id=${id}&last_n=5`
      );
      const json = await res.json();

      const categories = json.map((batch) => batch.batch_name);
      const data = json.map((batch) => batch.average_pct);

      setSummaryData({ categories, data });
    } catch (error) {
      console.error("خطأ في جلب بيانات المتوسط:", error);
    }
  };

  const fetchComparisonData = async () => {
    try {
      const res = await fetch(
        `https://plo.areez.co/api/plo/batches/results?program_id=${id}&last_n=5&page=1&per_page=30`
      );
      const json = await res.json();
      const data = json.data || [];

      if (data.length === 0) return;

      const ploSet = new Set();
      const targets = {};
      const allSeries = {
        overall_pct: [],
        male_pct: [],
        female_pct: [],
      };

      data.forEach((batch) => {
        const ploMap = {};
        batch.plo_results.forEach((plo) => {
          ploSet.add(plo.plo_code);
          targets[plo.plo_code] = plo.performance_target ?? 100;
          ploMap[plo.plo_code] = plo;
        });

        allSeries.overall_pct.push({
          name: `دفعة ${batch.batch_name}`,
          data: Array.from(ploSet).map(
            (code) => ploMap[code]?.overall_pct ?? 0
          ),
        });
        allSeries.male_pct.push({
          name: `دفعة ${batch.batch_name}`,
          data: Array.from(ploSet).map((code) => ploMap[code]?.male_pct ?? 0),
        });
        allSeries.female_pct.push({
          name: `دفعة ${batch.batch_name}`,
          data: Array.from(ploSet).map((code) => ploMap[code]?.female_pct ?? 0),
        });
      });

      setPloCodes(Array.from(ploSet));
      setSeriesData(allSeries);
      // setTargetValue(Object.values(targets)[0] || 100);

      const targetLine = {
        name: "المستهدف",
        type: "line",
        data: Array.from(ploSet).map((code) => targets[code] ?? 100),
        strokeWidth: 3,
        marker: {
          size: 5,
        },
      };

      // setTargetLine(targetLine);
      setTargetsMap(targets);
    } catch (err) {
      console.error("خطأ في جلب البيانات:", err);
    } finally {
      setLoading(false);
    }
  };
  const fetchSubDomainSummary = async () => {
    try {
      const res = await fetch(
        `https://plo.areez.co/api/plo/batches/domain/summary?program_id=${id}&last_n=5`
      );
      const json = await res.json();

      const batchNames = json.map((b) => b.batch_name);

      const subDomainsSet = new Set();
      json.forEach((batch) => {
        batch.sub_domain_classification.forEach((sd) => {
          subDomainsSet.add(sd.sub_domain_name);
        });
      });
      const subDomainNames = Array.from(subDomainsSet);

      const series = subDomainNames.map((subDomainName) => {
        return {
          name: subDomainName,
          data: json.map((batch) => {
            const match = batch.sub_domain_classification.find(
              (sd) => sd.sub_domain_name === subDomainName
            );
            return match ? match.average_pct : 0;
          }),
        };
      });

      setSubDomainChart({ series, categories: batchNames });
    } catch (error) {
      console.error("خطأ في جلب بيانات المجالات الفرعية:", error);
    }
  };
  const fetchMainDomainSummary = async () => {
    try {
      const res = await fetch(
        `https://plo.areez.co/api/plo/batches/domain/summary?program_id=${id}&last_n=5`
      );
      const json = await res.json();

      const batchNames = json.map((b) => b.batch_name);

      const mainDomainsSet = new Set();
      json.forEach((batch) => {
        batch.main_domain_classification.forEach((md) => {
          mainDomainsSet.add(md.main_domain_name);
        });
      });
      const mainDomainNames = Array.from(mainDomainsSet);

      const series = mainDomainNames.map((domainName) => {
        return {
          name: domainName,
          data: json.map((batch) => {
            const match = batch.main_domain_classification.find(
              (md) => md.main_domain_name === domainName
            );
            return match ? match.average_pct : 0;
          }),
        };
      });

      setMainDomainChart({ series, categories: batchNames });
    } catch (error) {
      console.error("خطأ في جلب بيانات المجالات الرئيسية:", error);
    }
  };


  useEffect(() => {
    if (!academicYearId) return;
  
    fetchStartedStudents();
    fetchCompletionStudentAverage();
    fetchCompletedMin();
    fetchEexitPoints();
    fetchTotalFaculty();
    fetchFacultyRatios();
    fetchPhdStats();
    fetchComparisonData();
    fetchSummaryData();
    fetchSubDomainSummary();
    fetchMainDomainSummary();
  }, [id, academicYearId]);
  

  const getAreaChartOptions = (categories) => ({
    chart: {
      height: 360,
      type: "area",
      toolbar: { show: false },
      dropShadow: {
        enabled: true,
        top: 10,
        blur: 10,
        opacity: 0.1,
      },
    },
    colors: ["#FFAB2D", "#AC4CBC", "#28a745", "#E91E63", "#00BCD4"],
    dataLabels: {
      enabled: true,
      style: { fontSize: "12px", colors: ["#444"] },

      background: {
        enabled: true,
        foreColor: "#fff",
        borderRadius: 10,
        padding: 4,
        backgroundColor: "#FF0000",
        opacity: 0.9,
        borderWidth: 1,
        borderColor: "#000",
      },
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    markers: {
      size: 5,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0.05,
        stops: [0, 90, 100],
      },
    },
    xaxis: {
      categories: categories,
      labels: {
        style: {
          fontSize: "14px",
          fontFamily: "Cairo",
          colors: "#787878",
        },
      },
    },
    yaxis: {
      max: 100,
      labels: {
        formatter: (val) => `${val}%`,
      },
    },
    tooltip: {
      shared: true,
      y: {
        formatter: (val) => `${val}%`,
      },
    },
    legend: {
      position: "bottom",
    },
  });




  return (
    <>
     <div className="d-flex justify-content-between align-items-center">
  <a
    href={`https://plo.areez.co/web#id=${id}&cids=5&menu_id=115&action=164&model=preparation.learning.program&view_type=form`}
    className="btn btn-sm btn-outline-info"
  >
    مراجعة
  </a>

  <button className="btn btn-sm btn-info">
    <i className="fa fa-check-circle-o"></i>
  </button>
</div>

<hr />
<div className="row mt-4">
   
   <div className="col-12 col-lg-2 mt-4">
     <div className="p-3 text-center">
       <ValueChangeCircle2
         percentage={startedStudents}
         size={180}
         strokeWidth={14}
         color="#27ae60"
         title={`عدد الطلاب الذين بدأوا البرنامج: ${startedStudents}`}
       />
     </div>
   </div>

   <div className="col-12 col-lg-2 mt-4">
     <div className="p-3 text-center">
       <ValueChangeCircle2
         percentage={completionStudentAverage}
         size={180}
         strokeWidth={14}
         color="#50E3C2"
         title={`عدد الطلاب  الذين أتموا البرنامج : ${completionStudentAverage}`}
       />
     </div>
   </div>

   <div className="col-12 col-lg-2 mt-4">
     <div className="p-3 text-center">
       <ValueChangeCircle
         percentage={completedMin}
         size={180}
         strokeWidth={14}
         color="#4A90E2"
         title={` معدل إتمام الطلاب في الحد الادنى`}
       />
     </div>
   </div>

   <div className="col-12 col-lg-2 mt-4">
     <div className="p-3 text-center">
       <ValueChangeCircle
         percentage={exitPoints}
         size={180}
         strokeWidth={14}
         color="#27ae60"
         title={`  معدل إتمام الطلاب لنقاط الخروج`}
       />
     </div>
   </div>

   <div className="col-12 col-lg-2 mt-4">
     <div className="p-3 text-center">
       <ValueChangeCircle
         percentage={totalFaculty}
         size={180}
         strokeWidth={14}
         color="#F7C8E0"
         title={`  معدل إتمام الطلاب لنقاط الخروج`}
       />
     </div>
   </div>
   {facultyRatios && (
     <div className="col-12 col-lg-6  mb-4">
       <SaudiFacultyPercentageChart
         maleData={maleData}
         femaleData={femaleData}
         categories={categories}
         title="نسبة هيئة التدريس حسب الجنسية والنوع"
         colors={["#3498db", "#e74c3c"]}
         height={350}
       />
     </div>
   )}

   {phdStats && (
     <div className="col-12 col-lg-6  mb-4">
       <PieUChart
         phd={phdStats.phd_percentage}
         nonPhd={phdStats.non_phd_percentage}
         colors={["#27ae60", "#e74c3c"]}
         title="نسبة حملة الدكتوراه في البرنامج"
         height={350}
         width={250}
       />
     </div>
   )}

   <div className="col-12 mt-4">
     <KPIChartsContainer2 selectedYear={academicYearId} program={id} />
   </div>


 </div>


 <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <h5 className="text-center mb-3">
              متوسط تحقيق نواتج التعلم حسب المجالات الرئيسية (آخر 5 دفعات)
            </h5>
            <ApexLineMainDomains
              series={mainDomainChart.series}
              categories={mainDomainChart.categories}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <h5 className="text-center mb-3">
              متوسط تحقيق نواتج التعلم حسب المجالات الفرعية (آخر 5 دفعات)
            </h5>
            <ApexLine4
              series={subDomainChart.series}
              categories={subDomainChart.categories}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <h5 className="text-center mb-3">
              متوسط تحقيق نواتج تعلم البرنامج لآخر 5 دفعات
            </h5>
            <ApexLine3
              categories={summaryData.categories}
              data={summaryData.data}
            />
          </div>
        </div>

        <Col lg={6}>
          <SubjectTablePage id={id} />
        </Col>
      </div>

      <div className="container mt-4" style={{ fontFamily: "Cairo" }}>
        <h3 className="text-center mb-4">
          مقارنة نواتج تعلم البرنامج عبر الدفعات
        </h3>

        {loading ? (
          <p className="text-center">جارٍ التحميل...</p>
        ) : (
          <>
            <>
              <div className="mb-5">
                <h5 className="text-center mb-3">الأداء الكلي (Overall)</h5>
                <ReactApexChart
                  options={getAreaChartOptions(ploCodes)}
                  series={[
                    ...seriesData.overall_pct.map((s) => ({
                      name: s.name,
                      data: s.data.map((val) => parseFloat(val.toFixed(2))),
                      type: "area",
                    })),
                    {
                      name: "المستهدف",
                      type: "line",
                      color: "red",
                      data: ploCodes.map((code) => targetsMap[code] ?? 100),
                      stroke: {
                        width: 4,
                        dashArray: 0,
                      },
                      marker: {
                        size: 6,
                        fillColor: "red",
                        strokeColor: "#fff",
                        strokeWidth: 2,
                      },
                    },
                  ]}
                  type="line"
                  height={360}
                />
              </div>

              <div className="mb-5">
                <h5 className="text-center mb-3">أداء الذكور (Male)</h5>
                <ReactApexChart
                  options={getAreaChartOptions(ploCodes)}
                  series={[
                    ...seriesData.male_pct.map((s) => ({
                      name: s.name,
                      data: s.data.map((val) => parseFloat(val.toFixed(2))),
                      type: "area",
                    })),
                    {
                      name: "المستهدف",
                      type: "line",
                      color: "red",
                      data: ploCodes.map((code) => targetsMap[code] ?? 100),
                      stroke: {
                        width: 4,
                        dashArray: 0,
                      },
                      marker: {
                        size: 6,
                        fillColor: "red",
                        strokeColor: "#fff",
                        strokeWidth: 2,
                      },
                    },
                  ]}
                  type="line"
                  height={360}
                />
              </div>

              <div className="mb-5">
                <h5 className="text-center mb-3">أداء الإناث (Female)</h5>
                <ReactApexChart
                  options={getAreaChartOptions(ploCodes)}
                  series={[
                    ...seriesData.female_pct.map((s) => ({
                      name: s.name,
                      data: s.data.map((val) => parseFloat(val.toFixed(2))),
                      type: "area",
                    })),
                    {
                      name: "المستهدف",
                      type: "line",
                      color: "red",
                      data: ploCodes.map((code) => targetsMap[code] ?? 100),
                      stroke: {
                        width: 4,
                        dashArray: 0,
                      },
                      marker: {
                        size: 6,
                        fillColor: "red",
                        strokeColor: "#fff",
                        strokeWidth: 2,
                      },
                    },
                  ]}
                  type="line"
                  height={360}
                />
              </div>
            </>
          </>
        )}
      </div>
    </>
  );
};

export default ProgramDetails;
